export default function WaryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 9.00084V12.7508M12 2.71484C9.73574 4.86508 6.72027 6.04442 3.598 6.00084C3.20074 7.21114 2.99887 8.47701 3 9.75084C3 15.3428 6.824 20.0408 12 21.3728C17.176 20.0408 21 15.3428 21 9.75084C21 8.44084 20.79 7.18084 20.402 6.00084H20.25C17.054 6.00084 14.15 4.75084 12 2.71484ZM12 15.7508H12.008V15.7588H12V15.7508Z"
        stroke="#FF574D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
